import ButtonMailto from "./ButtonMailto";

function Contact() {
    return (
        <article>
            <div className="large-card">
                    <h3 className="centered-title">Contact</h3>
                    <div className="separator"></div>
                    <p className="contact-text">If you have any questions or inquiries, feel free to send me an e-amil using the following button.</p>
                    <div className="separator"></div>
                    <a className="contact-button" href="mailto:pierrem.designs@gmail.com">Contact Me</a>
            </div>
        </article>
    )
}

export default Contact;